import gsap from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);


const sections = gsap.utils.toArray(".slide");

// Główny timeline do przesunięcia slide'ów
// let tl = gsap.timeline({
//   scrollTrigger: {
//     trigger: ".horizontal-sliders",
//     pin: ".main",
//     pinSpacing: true,
//     scrub: 1,
//     end: "+=3000",
//   }
// });

// tl.to(sections, {
//   xPercent: -100 * (sections.length - 1),
//   ease: "none",
// })
// .to('.main__element', {
//   width: '100%',
//   ease: "none",
// }, 0);


const process = document.querySelector('.horizontal-sliders');

if (process) {
  let sections = gsap.utils.toArray('.slide');


  gsap.set(sections.slice(1), { opacity: 0 });


  let tl = gsap.timeline({
    scrollTrigger: {
      trigger: process,
      pin: ".main",
	  pinSpacing: true,
      scrub: 1,
      snap: 1 / (sections.length - 1),
       end: "+=3000",
      onUpdate: self => {
        let progress = self.progress;
        sections.forEach((section, index) => {
          if (index === 0) {
            // Pierwsza sekcja zawsze widoczna
            gsap.to(section, { opacity: 1, duration: 0.2 });
          } else {
            // Oblicz opacity dla każdej sekcji na podstawie postępu scrollowania
            let sectionProgress = gsap.utils.clamp(
              0,
              1,
              (progress * sections.length - index + 1)
            );
            gsap.to(section, {
              opacity: sectionProgress,
              duration: 0.2,
              ease: "power2.out"
            });
          }
        });
      }
    }
  });


  tl.to(sections, {
    xPercent: -100 * (sections.length - 1),
    ease: "none"
  }).to('.main__element', {
  width: '90%',
  ease: "none",
}, 0);
}

